module.exports = __webpack_public_path__ + "static/media/foco.b07e0244.svg";